export const headerData = {
    title: 'Tableau de bord',
    submodules: [
    ],
}

// function createData(id, moduleName, ref) {
//     return { id, moduleName, ref };
// }